import type { MutationMeta } from '@tanstack/react-query';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      successMessage?: string;
      errorMessage?: string;
      silent?: boolean;
      /** Shown on the full-screen loader while this mutation runs. */
      loadingMessage?: string;
      /** Skip the global full-screen loader (e.g. notification read). */
      noScreenLoader?: boolean;
    };
  }
}

export function toastMeta(meta: MutationMeta): { meta: MutationMeta } {
  if (meta.noScreenLoader) return { meta };
  return {
    meta: {
      ...meta,
      loadingMessage: meta.loadingMessage ?? 'Please wait…',
    },
  };
}

export function formatApiError(error: unknown): string {
  if (error instanceof Error && error.message) return error.message;
  return 'Something went wrong';
}
